import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="accept_tos" as |field|>
      <div class="my-2 flex flex-row space-x-2">
        <field.Checkbox />
        <field.Label>I accept the Terms of Service</field.Label>
      </div>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>